import styled from 'styled-components';

const neve_png = "./img/efeitos/neve3.png"
const confete_png = "./img/efeitos/confetes_01.gif"
const pisca_pisca_png = "./img/efeitos/pisca_pisca_02.gif"


export const BG = styled.div`
  pointer-events: none;
  /*background: #ddd;*/
  /*Chamada das imagens de confetes.*/
  /* background-image: url(${neve_png}); */
  /*Define que a imagem irá repetir no eixo y, ou seja na vertical.*/
  background-repeat: repeat;
  /*Define o tamanho da altura usada em auto.*/
  height: 100%;
  /*Define a largura da página para ser aproveitada toda.*/
  width: 100%;

  /*Define a posição horizontal da página começando do primeiro pixel.*/
  left: 0;
  /*Define a orientação da página, ficando fixa.*/
  position: absolute;
  /*Define o início da página na parte superior,*/
  top: 0;
`

export const Neve = styled(BG)`
  background-image: url(${neve_png});

  /*Aqui é definida a animação para rodar em 4 segundos em linha reta sem parar.*/
  animation: snow 40s linear infinite;
  /*Abaixo é feita a mesma configuração de animação para diferentes prefixos de navegadores.*/
  -webkit-animation: snow 40s linear infinite;
  -moz-animation: snow 40s linear infinite;
  -ms-animation: snow 40s linear infinite;

	/*Aqui são definidas as posições da imagem.*/
	@keyframes snow {
		/*Primeiro a posição zero da imagem.*/
		0% {background-position: center 0%, center 0%, center 0%;}
		/*Depois a posição final.*/
		100% {background-position: center 1120px, center 1120px, center 1120px;}
	}
	/*Abaixo é feita a mesma configuração de keyfranes para diferentes prefixos de navegadores.*/
	@-moz-keyframes snow {
		0% {background-position: center 0%, center 0%, center 0%;}
		100% {background-position: center 1120px, center 1120px, center 1120px;}
	}
	@-webkit-keyframes snow {
		0% {background-position: center 0%, center 0%, center 0%;}
		100% {background-position: center 1120px, center 1120px, center 1120px;}
	}
	@-ms-keyframes snow {
		0% {background-position: center 0%, center 0%, center 0%;}
		100% {background-position: center 1120px, center 1120px, center 1120px;}
	}

`

export const Confetes = styled(Neve)`
  /*Chamada das imagens de confetes.*/
  background-image: url(${confete_png});
  filter: opacity(80%) blur(1px);

`
export const PiscaPisca = styled(BG)`
  /*Chamada das imagens de confetes.*/
  background-image: url(${pisca_pisca_png});
  filter: opacity(85%) blur(0.5px);

`


export const Chuva = Confetes;//Neve; // Chuva da vez
